import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import { Badge, Box } from '@mui/material';

export interface BadgesCellProps {
  align?: 'left' | 'center' | 'right' | 'inherit' | 'justify' | undefined;
  error?: number;
  warning?: number;
}

export const BadgesCell = ({
  align,
  error = 0,
  warning = 0,
}: BadgesCellProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap',
      }}
    >
      {error > 0 && (
        <Box sx={{ flexBasis: 30 }}>
          <Badge badgeContent={error} color="error" sx={{ right: -10 }} />
        </Box>
      )}
      {warning > 0 && (
        <Box sx={{ flexBasis: 30 }}>
          <Badge badgeContent={warning} color="warning" sx={{ right: -10 }} />
        </Box>
      )}
    </Box>
  );
};
